// SocketContext.js
import React, { createContext, useEffect, useState } from "react";
import { io } from "socket.io-client";
import { useAuth } from "./AuthContext";

export const SocketContext = createContext({
  socket: null,
  socketConnected: false,
});

const API_URL = process.env.REACT_APP_API_URL;

export const SocketProvider = ({ children }) => {
  const { currentUser } = useAuth();
  const [socket, setSocket] = useState(null);
  const [socketConnected, setSocketConnected] = useState(false);

  useEffect(() => {
    if (currentUser?.id) {
      const newSocket = io(API_URL, { transports: ["websocket"] });

      // Listen for the connection event and register the user
      newSocket.on("connect", () => {
        console.log("Connected with socket ID:", newSocket.id);
        setSocketConnected(true);
        newSocket.emit("REGISTER_USER", currentUser.id);
      });

      // Optionally handle disconnect events
      newSocket.on("disconnect", (reason) => {
        console.log("Socket disconnected:", reason);
        setSocketConnected(false);
        newSocket.emit("DEREGISTER_USER", currentUser.id);
      });

      setSocket(newSocket);

      // Cleanup: disconnect the socket when currentUser.id changes or component unmounts
      return () => {
        newSocket.disconnect(currentUser?.id);
        setSocket(null);
      };
    }
  }, [currentUser?.id]); // Effect only re-runs when currentUser.id changes

  return (
    <SocketContext.Provider value={{ socket, socketConnected }}>
      {children}
    </SocketContext.Provider>
  );
};
